const ToastStack = ({ toasts = [], onDismiss }) => (
  <div className="toast-stack" role="status" aria-live="polite">
    {toasts.map((toast) => (
      <div key={toast.id} className={`toast toast--${toast.type || "info"}`}>
        <div className="toast__body">
          <span className="toast__title">
            {toast.title ||
              (toast.type === "error"
                ? "Ops"
                : toast.type === "success"
                ? "Tudo certo"
                : "Atenção")}
          </span>
          <span className="toast__message">{toast.message}</span>
        </div>
        <button
          type="button"
          className="toast__close"
          onClick={() => onDismiss?.(toast.id)}
          aria-label="Fechar"
        >
          Fechar
        </button>
      </div>
    ))}
  </div>
);

export default ToastStack;
